import { transformSearch } from "@/api/helper.ts";
import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import counselsService from "../services/counsels-service";

export const counselInfoQueryOptions = (rollNumber: string, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["counsel-info"],
		queryFn: () => counselsService.getCounselInfo(rollNumber),
		...options,
	});
};
